<template>
  <div>
    <DxPopup
      v-model:visible="popupLinkVisible"
      :drag-enabled="true"
      :show-close-button="true"
      :close-on-outside-click="false"
      :show-title="true"
      :resizeEnabled="true"
      title="Quick Link"
    >
      <DxToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="before"
        :options="saveLinkButtonOptions"
      />

      <DxToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="after"
        :options="closeLinkButtonOptions"
      />

      <DxDataGrid
        :columns="columns"
        :data-source="dataStore1"
        :show-borders="true"
        :allow-column-resizing="true"
        
        :showRowLines="true"
        :height="400"
        :hover-state-enabled="true"
        :remote-operations="true"
        
        selection.mode="multiple"
        ref="dataGridRefKey"
        @selection-changed="onSelectionChanged"
      >
        <DxFilterRow :visible="true" />
       
        <DxPaging :page-size="5" />

        <DxPager
          :visible="true"
          display-mode="full"
          :show-page-size-selector="false"
          :show-info="true"
          :show-navigation-buttons="true"
        />
           <template #rlt-field="{ data: cellData }">
        <RltField :cell-data="cellData"></RltField>
      </template>
      </DxDataGrid>
    </DxPopup>
  </div>
</template>

<script>
import {
  DxColumn,
  DxFormItem,
  DxEditing,
  DxLookup,
  DxGrouping,
  DxColumnChooser,
  DxLoadPanel,
  DxToolbar,
  DxDataGrid,
  DxSelection,
  DxFilterRow,
  DxScrolling,
  DxPager,
  DxPaging,
} from "devextreme-vue/data-grid";

import { DxPopup, DxPosition, DxToolbarItem } from "devextreme-vue/popup";
import {
  getGridData,
  getHeaders,
  getQuickCreateDef,
} from "@include/utils/GridUtils.js";
import CustomStore from "devextreme/data/custom_store";
import RltField from "@/components/ListRelateField.vue";

let mRoute;

function setRoute(context) {
  mRoute = "/"+context.slug+"/" + context.routeDef + "/list";
}
const store = new CustomStore({
  key: "id",
  load: function (loadOptions) {
    var parameters = {};
    if (loadOptions.sort) {
      parameters.order_column = loadOptions.sort[0].selector;
      if (loadOptions.sort[0].desc) parameters.order_direction = "asc";
    }

    parameters.filter = JSON.stringify(loadOptions.filter);
    parameters.skip = loadOptions.skip;
    parameters.take = loadOptions.take;
    parameters.page = (parameters.skip + parameters.take) / parameters.take;

    let merged = { ...parameters, ...params };

    var config = {
      params: merged,
    };
    let listurl = mRoute;
    return axios
      .get(listurl, config)
      .then((response) => {
        return {
          data: response.data.results.data,
          totalCount: response.data.results.total,
        };
      })
      .catch(() => {
        throw "Data Loading Error";
      });
  },
});

export default {
  props: {
    
    routeDef: String,
    slug:String,
    parentRoute: String,
    parentId: String,
    
    relationDef: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    DxColumn,
    DxFormItem,
    DxEditing,
    DxLookup,
    DxGrouping,
    DxColumnChooser,
    DxLoadPanel,
    DxToolbar,
    DxDataGrid,
    DxSelection,
    DxFilterRow,
    DxPopup,
    DxPosition,
    DxToolbarItem,
    RltField,
    DxPager,
    DxPaging,
    DxScrolling,
  },
  data: function () {
    return {
      
      dataStore1: getGridData("/"+this.slug+"/" + this.routeDef + "/list", { id: "hh" }),
      headersDef: [],
      columns: [],
      selectedIds: [],
      popupLinkVisible: false,
      dataGridRefKey: "my-dat-grid",
      pageSizes: [10, 25, 50, 100],
      saveLinkButtonOptions: {
        icon: "save",
        text: "Save",
        onClick: this.onLinkRelation,
      },
      closeLinkButtonOptions: {
        text: "Close",
        onClick: () => {
          this.$refs.dataGridRefKey.instance.clearSelection();
          this.popupLinkVisible = false;
        },
      },
    };
  },
  mounted() {
    setRoute(this);
    /* load header for list */
    getHeaders(this.routeDef,this.slug)
      .then((response) => {
        this.columns = response.data;
      })
      .catch((error) => {});

     
  },
  methods: {
    showQuickLink() {
      this.popupLinkVisible = true;
    },
    /* for link relation */
    onSelectionChanged({ selectedRowsData }) {
      //SelectedRowKeys
      this.selectedIds = selectedRowsData;
    },
    onLinkRelation() {
      let idArray = this.selectedIds.map((value) => value.id);
      this.$inertia.post("/"+this.slug+"/" + this.parentRoute + "/linkrelate", {
        proute: this.parentRoute,
        pid: this.parentId,
        relateDef: this.relationDef,
        relateids: idArray,
      });

      this.popupLinkVisible = false;
      this.$refs.dataGridRefKey.instance.clearSelection();

      //this.dataGrid.refresh();
    },
  },
};
</script>

<style>
</style>